import iconPath from '@/assets/device-icons/iphone-15-pro-max.svg';

interface Iphone15ProMaxIconProps {
  className?: string;
}

export const Iphone15ProMaxIcon = ({ className = "h-5 w-5" }: Iphone15ProMaxIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="iPhone 15 Pro Max" 
      className={className}
    />
  );
};
